export default Object.freeze({
  en: {
    logout: "Logout",
  },
  ko: {},
  "zh-chs": {},
});
